import { isSamePath } from "@/lib/routing/activePath";

/**
 * Route predicates for surfaces that render their own full-screen immersive
 * chrome. There used to be four hand-rolled `isImmersiveRoute` copies with
 * three DIFFERENT route sets (drawer: create-event only; launcher/pill/search:
 * +website/email builder; coach: all six builders, no create-event) — the sets
 * diverge on purpose (the coach deliberately shows inside the create-event
 * wizard), so they stay separate predicates here instead of one boolean.
 * Add new builder routes HERE, not at the call sites.
 */

/** The shell-less create-event wizard. The AI drawer auto-closes here and the
 * floating background-jobs panel hides — the wizard's own bottom-right chrome
 * (Velo dock z-90, plan-checkout overlay z-100) must stay reachable. */
export function isCreateEventRoute(pathname: string | null | undefined): boolean {
  // normalize: a pasted `/create-event/` still IS the wizard.
  return isSamePath(pathname, "/create-event");
}

const ALL_BUILDER_PREFIXES = [
  "/website-builder",
  "/email-builder",
  "/document-builder",
  "/wallet-builder",
  "/calendar-builder",
  "/portal-builder",
] as const;

/** Every immersive builder editor. Used by the onboarding coach (which does
 * NOT hide on /create-event — it guides the wizard with special docking). */
export function isAnyBuilderRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return ALL_BUILDER_PREFIXES.some((p) => pathname.startsWith(p));
}

/** Historic narrower set shared by the AI launcher button, onboarding
 * pill/panel and global search: the wizard plus the two builders that own
 * their chrome end-to-end. Kept narrow on purpose — the other builders still
 * want the launcher/pill available. */
export function isImmersiveChromeRoute(
  pathname: string | null | undefined,
): boolean {
  if (!pathname) return false;
  return (
    pathname.startsWith("/website-builder") ||
    pathname.startsWith("/email-builder") ||
    isCreateEventRoute(pathname)
  );
}
